import { render, staticRenderFns } from "./JSelectRoleForApllication.vue?vue&type=template&id=3821e745&scoped=true&"
import script from "./JSelectRoleForApllication.vue?vue&type=script&lang=js&"
export * from "./JSelectRoleForApllication.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3821e745",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3821e745')) {
      api.createRecord('3821e745', component.options)
    } else {
      api.reload('3821e745', component.options)
    }
    module.hot.accept("./JSelectRoleForApllication.vue?vue&type=template&id=3821e745&scoped=true&", function () {
      api.rerender('3821e745', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/jeecgbiz/JSelectRoleForApllication.vue"
export default component.exports